'use client';

import { __awaiter, __generator } from '../_virtual/_tslib.js';

var apiSaveJob = function (data) {
    if (data === void 0) { data = {
        postData: {
            jobId: -1
        },
        accessToken: '',
        language: 'vi',
        baseUrl: ''
    }; }
    return __awaiter(void 0, void 0, void 0, function () {
        var apiUrl, savedJobResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    apiUrl = data.baseUrl + '/api-gateway/v1.0/save-job';
                    return [4 /*yield*/, fetch(apiUrl, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: "Bearer ".concat(data.accessToken),
                                'Accept-Language': data.language
                            },
                            body: JSON.stringify(data.postData)
                        })];
                case 1:
                    savedJobResponse = _a.sent();
                    return [4 /*yield*/, savedJobResponse.json()];
                case 2: return [2 /*return*/, _a.sent()];
            }
        });
    });
};
var apiUnsavedJob = function (data) {
    if (data === void 0) { data = {
        postData: {
            jobId: -1
        },
        accessToken: '',
        language: 'vi',
        baseUrl: ''
    }; }
    return __awaiter(void 0, void 0, void 0, function () {
        var apiUrl, savedJobResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    apiUrl = data.baseUrl + '/api-gateway/v1.0/unsave-job';
                    return [4 /*yield*/, fetch(apiUrl, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: "Bearer ".concat(data.accessToken),
                                'Accept-Language': data.language
                            },
                            body: JSON.stringify(data.postData)
                        })];
                case 1:
                    savedJobResponse = _a.sent();
                    return [4 /*yield*/, savedJobResponse.json()];
                case 2: return [2 /*return*/, _a.sent()];
            }
        });
    });
};

export { apiSaveJob, apiUnsavedJob };
//# sourceMappingURL=services.js.map
